export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_05.e7432cf5.jpg";